<script>
export default {
  name: 'StatisticTile',
  props: {
    title: String,
    icon: String,
    value: [String, Number],
    note: String,
  },
}
</script>

<template lang="pug">
  .b-statistic-tile
    ._title {{ title }}
      Icon(:name="icon")
    ._value {{ value }}
      ._note {{ note }}
</template>

<style scoped lang="scss">
.statistic-tile {
  padding: 16px;
  background: #F8F9FC;
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  &__value {
    font-size: 32px;
    line-height: 30px;
    letter-spacing: 0.01em;
    color: #1E3147;
    display: flex;
    align-items: flex-end;
    gap: 10px;
    margin-top: auto;
  }

  &__note {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #92A0B0;
  }

  &__title {
    font-weight: 400;
    font-size: 12px;
    color: #1E3147;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    gap: 10px;

    svg {
      flex-shrink: 0;
    }
  }
}


</style>
